export const CMSAPI = "/api/cms";
export const API_DOWNLOADPDF = "/api/pdf";
import { getPublicEnvConfig } from "./env";
const { BACKEND_HOST, BRANCHNAME } = getPublicEnvConfig();
function getFullUrl(path: string) {
    return BACKEND_HOST + path;
}
// export const GRAPHQL_API = getFullUrl("/graphql/pr48950-wyc");
export const GRAPHQL_API = () => {
    if (BRANCHNAME !== 'production')
        return getFullUrl("/api/client/v2.0/app/pr48950-pub-innovationddpstaging-khtfg/graphql");
    return getFullUrl("/api/client/v2.0/app/pr48950-pub-innovationddpprod-lhtrq/graphql");
}
export const FP_GET_STORE = getFullUrl("/api/wyc/site/getSite");
export const FP_CREATE_STORE = getFullUrl("/api/wyc/site/createSite");
export const FP_UPDATE_STORE = getFullUrl("/api/wyc/site/updateSite");
export const FP_RECOMMENDATION = getFullUrl("/api/wyc/recommendation");
export const FP_INTERACTION = getFullUrl("/api/wyc/interaction/create");
